import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { HashRouter } from 'react-router-dom';
import Navigation from './components/Navigation';
import HeroSection from './sections/HeroSection';
import ServicesSection from './sections/ServicesSection';
import ShowcaseSection from './sections/ShowcaseSection';
import AboutSection from './sections/AboutSection';
import GoogleBusinessSection from './sections/GoogleBusinessSection';
import FAQSection from './sections/FAQSection';
import ContactSection from './sections/ContactSection';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="loading-content"
        >
          <motion.img 
            src="https://media-manager-c.questera.ai/greta-media/25fe57c277fc4d49baa2815a1646d92e367cb2ce89a7d2c278a4f8202228d92c658a999133b0fffe7649687a42276768/images/aW1hZ2UvcG5n/80a798bdc470f1a4284e1fcfb2b8a9e6.png" 
            alt="Verkstad360 Loading" 
            className="loading-logo"
            animate={{ 
              scale: [0.95, 1.05, 0.95],
              opacity: [0.7, 1, 0.7]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </motion.div>
        
        <style jsx>{`
          .loading-screen {
            position: fixed;
            inset: 0;
            background: #07070E;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            flex-direction: column;
          }
          
          .loading-logo {
            height: 91px; /* Reduced by 30% from 130px */
            max-width: 90vw;
            object-fit: contain;
            border-radius: 10px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          }
        `}</style>
      </div>
    );
  }

  return (
    <HashRouter>
      <div className="app">
        <div className="app-background" />
        <div className="noise-overlay" />
        
        <Navigation />
        
        <main>
          <HeroSection />
          <ShowcaseSection />
          <ServicesSection />
          <AboutSection />
          <GoogleBusinessSection />
          <FAQSection />
          <ContactSection />
        </main>
        
        <footer className="footer">
          <div className="footer-content">
            <div className="footer-logo">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/25fe57c277fc4d49baa2815a1646d92e367cb2ce89a7d2c278a4f8202228d92c658a999133b0fffe7649687a42276768/images/aW1hZ2UvcG5n/80a798bdc470f1a4284e1fcfb2b8a9e6.png" 
                alt="Verkstad360 Footer Logo" 
                className="footer-logo-img" 
              />
            </div>
            <p>© 2026 Verkstad 360 Car & Marine Service | All rights reserved </p>
            <p className="mt-2 text-sm opacity-50">Prästängsvägen 11, Strömstad, Sweden</p>
            <p className="mt-2 text-sm opacity-50">Crafted with ❤️ by <a href="https://www.bmi-software.gr"><u>BMI Software S.A</u></a></p>
          </div>

          <style jsx>{`
            .footer {
              padding: 4rem 2rem;
              border-top: 1px solid rgba(221, 219, 230, 0.1);
              text-align: center;
              color: #848489;
              background: rgba(0, 0, 0, 0.2);
            }

            .footer-logo {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 1.5rem;
            }

            .footer-logo-img {
              height: 50px; /* Reduced by 30% from 80px */
              width: auto;
              object-fit: contain;
              border-radius: 6px;
              opacity: 0.8;
              transition: opacity 0.3s;
            }

            .footer-logo-img:hover {
              opacity: 1;
            }
          `}</style>
        </footer>
      </div>
    </HashRouter>
  );
}

export default App;